import Link from 'components/links/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { formatDistance } from 'utils/formatting';

import PoiTypeIcon from '../icons/PoiTypeIcon';

function PoiDistanceListItem({ type, name, slug, distance }) {
    return (
        <div className="flex justify-between space-x-4">
            <Link to={`/ideja/${slug}`} styles="hover:underline" prefetch={false}>
                <div className="flex items-center space-x-2 leading-tight">
                    <PoiTypeIcon slug={type} size={22} />
                    <span>{name}</span>
                </div>
            </Link>
            <div className="font-medium text-sm flex-shrink-0">{formatDistance(distance)}</div>
        </div>
    );
}

PoiDistanceListItem.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired
};

export default PoiDistanceListItem;
